import { isPlainObject, isArray } from './types'
/**
 * 扩展对象:同 Zepto $.extend
 * @param  {Object} target
 */
export function extend(target, ...args) {
  let deep

  if (typeof target === 'boolean') {
    deep = target
    target = args.shift()
  }

  function _extend(_target, source, _deep) {
    for (const key in source) {
      if (_deep && (isPlainObject(source[key]) || isArray(source[key]))) {
        if (isPlainObject(source[key]) && !isPlainObject(_target[key])) {
          _target[key] = {}
        }
        if (isArray(source[key]) && !isArray(_target[key])) {
          _target[key] = []
        }
        _extend(_target[key], source[key], _deep)
      } else if (source[key] !== undefined) {
        _target[key] = source[key]
      }
    }
  }
  args.forEach(function(arg) {
    _extend(target, arg, deep)
  })
  return target
}
